import React, { useState } from 'react';
import { ProductListView } from './ProductListView';
import { ProductNameDimensionsView } from './ProductNameDimensionsView';

type ProductsSubTab = 'lista' | 'dimensoes';

const SUB_TABS: { id: ProductsSubTab; label: string }[] = [
  { id: 'lista', label: 'Lista' },
  { id: 'dimensoes', label: 'Nomes e Dimensões' },
];

/**
 * Conteúdo da aba "Produtos", dividido em sub-abas.
 *
 * O padrão de sub-aba no repositório é o segmented control com estado local
 * (ver StockAnalyticsReportView e DreReportView) — não há `Tabs` aninhado.
 * Trocar de sub-aba desmonta a anterior, então a listagem recarrega ao voltar;
 * é o mesmo comportamento das outras telas.
 */
export const ProductsTabView: React.FC = () => {
  const [subTab, setSubTab] = useState<ProductsSubTab>('lista');

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-1 bg-slate-100 rounded-lg p-1 w-fit">
        {SUB_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setSubTab(tab.id)}
            className={
              subTab === tab.id
                ? 'px-4 py-1.5 text-sm font-medium rounded-md bg-white text-emerald-700 shadow-sm'
                : 'px-4 py-1.5 text-sm font-medium rounded-md text-slate-500 hover:text-slate-700'
            }
          >
            {tab.label}
          </button>
        ))}
      </div>

      {subTab === 'lista' ? <ProductListView /> : <ProductNameDimensionsView />}
    </div>
  );
};

export default ProductsTabView;
